// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Redux:
import { toggleAccountDropdown } from 'actions/site'
import { togglePlaying } from 'actions/schedule'

class NowPlayingButton extends React.Component {
	handleClick = () => {
		const { siteId, nowPlaying, togglePlaying, toggleAccountDropdown } = this.props

		if ( ! siteId ) {
			toggleAccountDropdown()

			return
		}

		if ( ! nowPlaying ) {
			return
		}

		togglePlaying()
	}

	render() {
		const { isBuffering, nowPlaying, isPlaying, mediaError } = this.props
		let playClassName = 'now-playing-player'

		let showLoading = false

		if ( ! nowPlaying || ( isBuffering && isPlaying ) ) {
			showLoading = true
			playClassName += ' is-loading'
		}

		if ( isPlaying && ! showLoading && ! mediaError ) {
			playClassName += ' is-playing'
		}

		return (
			<div className={ playClassName } onClick={ this.handleClick }>
				<svg x="0px" y="0px" viewBox="0 0 213.7 213.7" >
					<title>Play</title>

					<circle className="-circle" fill="none" strokeWidth="7" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" cx="106.8" cy="106.8" r="103.3"></circle>

					<polygon className="-triangle" fill="none" strokeWidth="7" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" points="73.5,62.5 148.5,105.8 73.5,149.1 "></polygon>

					<g className="-pause">
						<rect x="78" y="64" rx="5" ry="5" height="85" width="10" />
						<rect x="124" y="64" rx="5" ry="5" height="85" width="10" />
					</g>

					<g className="-dots">
						<circle cx="65" cy="105" r="10"></circle>
						<circle cx="105" cy="105" r="10"></circle>
						<circle cx="145" cy="105" r="10"></circle>
					</g>

					<linearGradient id="play-gradient">
						<stop stopColor="#C51766" />
						<stop offset="100%" stopColor="#EE8002" />
					</linearGradient>

					<linearGradient id="pause-gradient" x1="0" x2="0" y1="0" y2="1">
						<stop stopColor='#C51766'/>
						<stop offset='100%' stopColor='#EE8002'/>
					</linearGradient>
				</svg>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		isBuffering: state.schedule.isBuffering,
		isPlaying: state.schedule.isPlaying,
		isLive: state.schedule.isLive,
		mediaError: state.schedule.mediaError,
		canFastForward: state.schedule.canFastForward,
		showRewindWarning: state.schedule.showRewindWarning,
		nowPlaying: state.schedule.nowPlaying,
		nowPlayingLive: state.schedule.nowPlayingLive,
		playerOffset: state.schedule.playerOffset,
		siteId: state.schedule.siteId,
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		togglePlaying() {
			dispatch( togglePlaying() )
		},

		toggleAccountDropdown() {
			dispatch( toggleAccountDropdown() )
		},
	}
}

export default connect( mapStateToProps, mapDispatchToProps )( NowPlayingButton )
